let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("drAPP")).then(() => parcelRequire('3DBMU'));